import axios from "axios";
const BASE_API_URL = process.env.REACT_APP_API_URL;

// API 1: Create Razorpay Order
export const createRazorpayOrderApi = async (customerID, orderID, amt, deviceID) => {
  return axios.post(`${BASE_API_URL}/BarejaPay/PayByCustomerOnlineForOrder`, {
    customerID: customerID,
    orderID: orderID,
    amt: amt,
    deviceID: deviceID,
  });
};

// API 2: Update Payment Status after successful payment
export const updateRazorpayPaymentApi = async (data) => {
  return axios.post(`${BASE_API_URL}/BarejaPay/PayByCustomerOnlineForOrderUpdate`, {
    customerID: data.customerID,
    orderID: data.orderID,
    razorTransactionID: data.razorTransactionID,
    razorOrderNo: data.razorOrderNo,
    receiptNo: data.receiptNo,
    llcID: data.llcID,
    paymentModeID: data.paymentModeID,
  });
};